<template>
    <a-result :title="$t('user.security.tfa.step_1.title')" :sub-title="$t('user.security.tfa.step_1.sub_title')">
        <template #icon>
            <KeyOutlined class="icon-color" />
        </template>
        <template #extra>
            <div class="section-body">
                <div
                    data-cy="field-tfa-app"
                    class="input-container full pb-4 tfa-type-radio-group"
                    :class="{ 'text-left': tfa_enforced }"
                >
                    <a-radio-group v-model:value="tfa_option" name="radioGroup">
                        <a-radio :value="'app'" class="radio-app">
                            {{ $t('user.security.tfa.fields.app') }}
                            <span class="text-help radio-app" :class="{ 'mb-4': tfa_enforced }">
                                {{ $t('user.security.tfa.help.app') }}
                            </span>
                        </a-radio>
                        <a-radio :value="'email'" class="radio-email">
                            {{ $t('user.security.tfa.fields.email') }}
                            <span class="text-help radio-email">
                                {{ $t('user.security.tfa.help.email') }}
                            </span>
                        </a-radio>
                    </a-radio-group>
                </div>
            </div>
            <div class="text-right">
                <a-button v-if="!tfa_enforced" @click="cancelTFA" data-cy="tfa-cancel-button">
                    {{ $t('user.security.tfa.cancel') }}
                </a-button>
                <a-button type="primary" @click="chooseTFA" :loading="tfa_processing" data-cy="tfa-next-step-1-button">
                    {{ $t('user.security.tfa.continue') }}
                </a-button>
            </div>
        </template>
    </a-result>
</template>

<script>
import { KeyOutlined } from '@ant-design/icons-vue';

export default {
    components: { KeyOutlined },
    props: {
        tfa_enforced: {
            type: Boolean,
            default: false,
        },
        tfa_processing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tfa_option: 'app',
        };
    },
    methods: {
        cancelTFA() {
            this.$emit('cancelTFA');
        },
        chooseTFA() {
            this.$emit('chooseTFA', this.tfa_option);
        },
    },
};
</script>
